export const messages = {
  en: {
    workTaskDetail: {
      title: 'Work Task Detail',
      workId: 'Work ID',
      workName: 'Work Name',
      typeName: 'Type Name',
      workCycle: 'Work Cycle',
      once: 'One-time',
      periodic: 'Periodic',
      startTime: 'Start Time',
      endTime: 'End Time',
      createUserName: 'Creator',
      curStaffName: 'Handler',
      curCopyName: 'CC',
      stateName: 'Status',
      createTime: 'Create Time',
      attachment: 'Attachment',
      select: 'Select',
      content: 'Content',
      status: 'Status',
      pending: 'Pending',
      processed: 'Processed',
      flow: 'Work Flow',
      preStaff: 'Previous Handler',
      staff: 'Handler',
      validTime: 'Valid Time',
      time: 'Time',
      type: 'Type',
      handler: 'Handler Process',
      copy: 'CC Process',
      process: 'Process',
      remark: 'Remark',
      attachmentList: 'Attachments',
      action: 'Action',
      pleaseSelect: 'Please Select',

      transfer: 'Transfer',
      nextHandler: 'Next Handler',
      selectNextHandler: 'Please select next handler',
      inputRemark: 'Please input remark',
      submitSuccess: 'Submit success',
      submitFailed: 'Submit failed',
      chooseStaffName:'Choose StaffName'
    }
  },
  zh: {
    workTaskDetail: {
      title: '任务单详情',
      workId: '工单编号',
      workName: '工单名称',
      typeName: '类型名称',
      workCycle: '标识',
      once: '一次性工单',
      periodic: '周期性工单',
      startTime: '开始时间',
      endTime: '结束时间',
      createUserName: '发起人',
      curStaffName: '处理人',
      curCopyName: '抄送人',
      stateName: '状态',
      createTime: '创建时间',
      attachment: '附件',
      select: '选择',
      content: '工作单内容',
      status: '状态',
      pending: '待处理',
      processed: '已处理',
      flow: '工作单流转',
      preStaff: '前处理人',
      staff: '处理人',
      validTime: '任务有效期',
      time: '时间',
      type: '类型',
      handler: '处理人办理',
      copy: '抄送人办理',
      remark: '意见',
      attachmentList: '工作单附件',
      action: '动作',
      pleaseSelect: '请选择',
      process: '办理',
      transfer: '转单',
      nextHandler: '下一处理人',
      selectNextHandler: '必填，请选择下一处理人',
      inputRemark: '必填，请填写工单说明',
      submitSuccess: '办理成功',
      submitFailed: '办理失败',
      chooseStaffName:'请选择下一处理人'
    }
  }
}